import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { ResponsePackage } from '../models/util.model';
import { Role } from '../models/role.model';
import { Observable } from 'rxjs';
import { RmuDtoCreate, RmuStats } from '../models/rmu.model';

import { AssetStatusEnum } from '../models/assetStatus.model';
import { Image } from '../models/image.model';

@Injectable({
  providedIn: 'root',
})
export class RmuService {
  private pathApi = this.config.setting['pathApi'] + 'rmu/';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient, private config: AppConfig) {}

  get(id: number) {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}${id}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, {
      observe: 'response',
    });
  }

  getRmuStats(obj: any): Observable<any> {
    return this.http.post<ResponsePackage<RmuStats>>(
      `${this.pathApi}getStats`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }

  download(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
  recall(id: number) {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}recall/${id}`, {
      headers: this.headers,
      observe: 'response',
    });
  }
  auditrmu(id: number): Observable<any> {
    return this.http.post(`${this.pathApi}auditRmu/${id}`, id, {
      headers: this.headers,
      observe: 'response',
    });
  }
  assignRmu(rmuId: number, userId: number, assetStatus: AssetStatusEnum) {
    const obj = {
      entityId: rmuId,
      userId: userId,
      assetStatus: assetStatus,
    };
    return this.http.post<ResponsePackage<string>>(
      `${this.pathApi}assignRmu`,
      obj,
      { observe: 'response' }
    );
  }
  uploadPicture(obj: any, image: File) {
    let formData: FormData = new FormData();
    formData.append('entityId', obj.entityId);
    formData.append('image', image, image.name);
    formData.append('imageType', obj.imageType);
    formData.append('guid', obj.guid);
    formData.append('url', obj.url);
    formData.append('imageId', obj.imageId);

    return this.http.post<ResponsePackage<Image>>(
      `${this.pathApi}uploadPicture`,
      formData,
      { observe: 'response' }
    );
  }
  getDtDataQuality(id: number): Observable<any> {
    return this.http.get(`${this.pathApi}getDtDataQuality/${id}`, {
      observe: 'response',
    });
  }
  rejectRmu(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}rejectRmu`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
  approveRmu(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}approveRmu`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  save(rmu: RmuDtoCreate): Observable<any>{
    return this.http.post(`${this.pathApi}save`, rmu, {observe: 'response'})
  }
}
